import { useEffect, useState } from "react";
import "../../css/ErrorFallback.css";
import { useParams } from "react-router-dom";


export default function ErrorFallback({ error, reset }) {
  const [countdown, setCountdown] = useState(5);
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();

  useEffect(() => {
    if (countdown <= 0) {
      window.location.href = `/${lang}`;
      return;
    }

    const timer = setTimeout(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  const handleRetry = () => {
    reset?.();
    window.location.href = `/${lang}`;
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  return (
    <div className="error-container">
      <div className="error-card">
        <div className="error-icon">⚠️</div>

        <h2>Something went wrong</h2>

        <p className="redirect-text">
          Redirecting to home in <span>{countdown}</span> second{countdown !== 1 ? "s" : ""}...
        </p>

        {process.env.NODE_ENV === "development" && (
          <pre className="error-box">An unexpected application error occurred.</pre>
        )}

        <button className="retry-button" onClick={handleRetry}>
          Home
        </button>
      </div>
    </div>
  );
}